import DOMPurify from "dompurify";

// CMS legal bodies ship their own <h1> per section. A page must have exactly one
// H1 (the page title), so demote CMS headings one level before rendering.
export const sanitizeCmsHtml = (html) =>
  DOMPurify.sanitize(html || "").replace(/<(\/?)h1(\s|>)/gi, "<$1h2$2");

export default sanitizeCmsHtml;
